import * as React from 'react';

function HesDarkIcon({ 'aria-hidden': ariaHidden = true, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      aria-hidden={ariaHidden}
      {...props}
    >
      <defs>
        <path
          id="jnvibrcrja"
          d="M.977 8.357C.41 7.375.074 6.275 0 5.143 0 2.303 2.303 0 5.143 0 6.62-.007 8.029.629 9 1.742 9.971.63 11.38-.008 12.857 0 15.697 0 18 2.303 18 5.143c-.074 1.132-.409 2.232-.977 3.214h-3.04l-1.126-4.03c-.073-.264-.305-.453-.578-.47-.278-.02-.538.14-.643.399l-2.72 6.486-2.571-4.628c-.112-.208-.33-.338-.566-.338-.236 0-.453.13-.565.338L4.1 8.357H.977zM13.5 9.643c-.297.01-.563-.183-.643-.47L12.1 6.43 9.59 12.446c-.092.227-.307.382-.552.398H9c-.232 0-.446-.125-.56-.328L5.819 7.791 5.072 9.29c-.109.216-.33.353-.572.354H1.716c1.986 2.954 4.274 5.692 6.828 8.17.12.122.285.19.456.19.171 0 .336-.068.456-.19 2.554-2.478 4.842-5.216 6.828-8.17H13.5z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0H24V24H0z"
                  transform="translate(-171 -633) translate(155 610) translate(16 22.014) translate(0 1)"
                />
                <g transform="translate(-171 -633) translate(155 610) translate(16 22.014) translate(0 1) translate(3 3)">
                  <mask id="p4byrxf3fb" fill="#fff">
                    <use xlinkHref="#jnvibrcrja" />
                  </mask>
                  <use fill="#000" fillRule="nonzero" xlinkHref="#jnvibrcrja" />
                  <g fill="#383C52" mask="url(#p4byrxf3fb)">
                    <path d="M0 0H24V24H0z" transform="translate(-3 -3)" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default HesDarkIcon;
